import { DataCache, QueryResultsRelationship, ForeignKeyRelationship, OneToOneRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { PastExportsResponse, PastExportsBill } from 'data/models/PastExportsResponse';

export class PastExportsCache extends DataCache {
    PastExportsResponses = PCCollection(PastExportsResponse);
    PastExportsBills     = PCCollection(PastExportsBill);

    constructor(data : PCCache) {
        super();

        new OneToOneRelationship    (this.PastExportsResponses, data.BillingSystems, r => r.BillingSystem, null, r => r.Id());
        new QueryResultsRelationship(this.PastExportsResponses, this.PastExportsBills, r => r.Bills);
        new SharedKeyRelationship   (this.PastExportsBills, data.Bills, b => b.Bill, null);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/quickbooksexports/pastexportscache.ts